import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  get sidebar() {
    return this.element.querySelector("div[data-element='sidebar']");
  }

  get menu() {
    return this.element.querySelector("div[data-element='menu']");
  }

  get background() {
    return this.element.querySelector("div[data-element='background']");
  }

  open() {
    document.body.classList.add('modal-open');
    this.sidebar.classList.remove('hidden');
    this.background.classList.replace('opacity-0', 'opacity-100');

    setTimeout(() => {
      this.menu.classList.replace('-translate-x-full', 'translate-x-0');
    }, 10);
  }

  close() {
    document.body.classList.remove('modal-open');
    this.menu.classList.replace('translate-x-0', '-translate-x-full');
    this.background.classList.replace('opacity-100', 'opacity-0');

    setTimeout(() => {
      this.sidebar.classList.add('hidden');
    }, 300);
  }

  resetFilters(event) {
    event.preventDefault();

    const form = document.querySelector('#mobile-filters form');
    if (form) form.reset();

    document.querySelectorAll('#price_range, #distance_range').forEach(sliderElm => {
      sliderElm.noUiSlider.reset();
    });

    Turbo.clearCache();
    Turbo.visit(event.target.href);
  }
}
